export const ALERTS_ACTION_TYPES = {
    ALERTS_UPDATE: 'ALERTS_UPDATE',
};